import { Droppable, type DroppableProps } from 'react-beautiful-dnd';
import { useEffect, useState } from 'react';

export function GStrictModeDroppable({ children, ...props }: DroppableProps) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(true);
    return () => {
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
}
